
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CardFooter } from "@/components/ui/card";
import { Share, Trash } from "lucide-react";

type Entry = {
  id: string;
};

type EntryCardFooterProps = {
  entry: Entry;
  isOwner: boolean;
  isSharedEntryState: boolean;
  handleShare: () => void;
  handleRemoveShared: () => void;
};

export const EntryCardFooter: React.FC<EntryCardFooterProps> = ({
  entry,
  isOwner,
  isSharedEntryState,
  handleShare,
  handleRemoveShared
}) => {
  return (
    <CardFooter className="border-t pt-3 flex justify-between">
      <Button variant="outline" size="sm" asChild className="flex-1 mr-2">
        <Link to={`/dashboard/entry/${entry.id}`}>View</Link>
      </Button>

      {isOwner && !isSharedEntryState && (
        <Button 
          variant="outline" 
          size="sm" 
          className="flex-1 flex items-center justify-center mr-2" 
          asChild
        >
          <Link to={`/dashboard/edit/${entry.id}`}>Edit</Link>
        </Button>
      )}
      
      {isOwner && isSharedEntryState && (
        <Button 
          variant="outline" 
          size="sm" 
          className="flex-1 flex items-center justify-center mr-2 text-red-600 hover:text-red-700" 
          onClick={handleRemoveShared}
        >
          <Trash className="h-4 w-4 mr-1" />
          Remove
        </Button>
      )}
      
      <Button
        variant="outline"
        size="sm"
        className="flex items-center justify-center"
        onClick={handleShare}
      >
        <Share className="h-4 w-4" />
        <span className="sr-only">Share</span>
      </Button>
    </CardFooter>
  );
};
